// The certificate-name section talks to /api/v1/admin/certificate-names and
// friends, and those endpoints validate every filter they accept. The lists
// below are therefore the API contract, not a display preference: an unknown
// `sort_by` or `category` comes back as a 422, not as an ignored parameter.

// CertificateName::category on the backend. A name may also have no category
// at all, which the API expresses as null (see NO_CERTIFICATE_CATEGORY).
export const CERTIFICATE_CATEGORIES = [
    'school',
    'ambassador',
    'best_ambassador',
    'coordinator',
    // The education-department representatives, first seen in the season-four
    // sheet (data/v3.xlsx on the backend).
    'representative',
];

// The "any / unspecified" choice in the filters and in the create form. Kept as
// an empty string because that is what an untouched MUI select holds; the
// service module turns it into null (clear the category) or drops it (no
// category filter) as appropriate.
export const NO_CERTIFICATE_CATEGORY = '';

// The three outcomes the verifier can return.
//   verified     - exactly one approved name scored at or above the threshold.
//   ambiguous    - two or more DIFFERENT approved names did, so nobody can say
//                  which one was meant. This is not a pass.
//   not_verified - nothing reached the threshold.
export const VERIFICATION_STATUSES = ['verified', 'ambiguous', 'not_verified'];

// The threshold those outcomes are judged against, as the settings endpoint
// accepts it: UpdateSettingsRequest's bounds - anything outside is a 422. The
// locale strings validation.certificateThresholdRange and
// admin.certificateNames.threshold.rangeHint spell these numbers out, so keep
// them in step.
export const CERTIFICATE_THRESHOLD_MIN = 50;
export const CERTIFICATE_THRESHOLD_MAX = 100;

// Columns the two list endpoints accept in `sort_by`. A header click on
// anything outside these lists must never reach the API.
export const CERTIFICATE_NAME_SORT_FIELDS = [
    'id',
    'name',
    'category',
    'created_at',
    'updated_at',
];

export const VERIFICATION_SORT_FIELDS = [
    'id',
    'entered_name',
    'matched_name',
    'similarity',
    'status',
    'created_at',
];

// The API's own default page size, and the sizes it is worth offering. The
// names table holds ~18k rows, so every table here pages server-side.
export const CERTIFICATE_PER_PAGE = 25;
export const CERTIFICATE_PER_PAGE_OPTIONS = [25, 50, 100];

// Long enough that typing a school name is one request, short enough to feel
// immediate.
export const SEARCH_DEBOUNCE_MS = 400;

// How an Excel import treats the list it goes into (CertificateNameImporter on
// the backend). There is deliberately no default: replace removes every name
// the file does not hold, so the operator always picks one.
//   append  - add the file's new names, keep everything already there.
//   replace - make the list hold exactly the file's names.
export const IMPORT_MODE_APPEND = 'append';
export const IMPORT_MODE_REPLACE = 'replace';

// What the upload endpoints accept (StoreCertificateNameListRequest), as an
// <input accept> string. The backend checks again; this only narrows the picker.
export const CERTIFICATE_FILE_ACCEPT = '.xlsx,.xlsm,.xls,.ods,.csv';

// The three ways the "new list" dialog can start.
export const LIST_CREATE_EMPTY = 'empty';
export const LIST_CREATE_MANUAL = 'manual';
export const LIST_CREATE_EXCEL = 'excel';
